import type { TimelineSection } from './TimelineViewer';
import { buildDaySections, type DaySectionItem } from './buildDaySections';

export function mapToDaySections<TRaw, TItem extends DaySectionItem>(
  items: readonly TRaw[],
  mapItem: (item: TRaw, index: number) => TItem
): readonly TimelineSection<TItem>[] {
  return buildDaySections(items.map(mapItem));
}
